import * as React from 'react';

import {Button} from 'shells/button/button';
import {CheckIcon} from 'shells/icon';
import {ListItem} from 'shells/list-item/generic/list-item';
import {ListItemMeta} from 'shells/list-item/generic/list-item-meta';
import {ListView} from 'shells/list-view/list-view';
import {Body} from 'shells/typography/body';
import {Title} from 'shells/typography/title';

import type {Webcast} from 'nutshell-graphql-types';

import {launchIntercomMessenger} from '../../../../intercom';

import {getTimestampForWebcast} from './get-timestamp-for-webcast';
import {useDemioRegister} from './use-demio-register';

import styles from './upcoming-webcasts.module.css';

type Props = {
    upcomingEvents: Webcast[];
    onClose: () => void;
    isChangingReservation?: boolean;
    isLoading?: boolean;
};

export function UpcomingWebcasts(props: Props) {
    const register = useDemioRegister();

    const title = props.isChangingReservation ? 'Can’t make it?' : 'Upcoming times';

    return (
        <div className={styles['upcoming-webcasts']}>
            <div className={styles.header}>
                <div className='mb-4'>
                    <Title>{title}</Title>
                </div>
                <Body>
                    Pick one of our upcoming dates. Or, if you’d prefer, you can{' '}
                    <Button
                        variant='text-primary'
                        onClick={() => {
                            launchIntercomMessenger();
                            props.onClose();
                        }}
                        noPadding={true}
                        size='big'
                    >
                        chat with our team
                    </Button>
                    .
                </Body>
            </div>
            <div className={styles.list}>
                <ListView
                    collection={props.upcomingEvents}
                    isLoading={props.isLoading}
                    renderRow={(item) => (
                        <ListItem
                            key={item.id}
                            actions={[
                                item.isCurrentUserRegistered ? (
                                    <div key='registered' className='font-size-normal'>
                                        <CheckIcon /> Registered
                                    </div>
                                ) : (
                                    <Button
                                        key='register'
                                        variant='text-primary'
                                        size='big'
                                        onClick={() => register({webcast: item})}
                                        noPadding={true}
                                    >
                                        Register
                                    </Button>
                                ),
                            ]}
                        >
                            <ListItemMeta
                                title={getTimestampForWebcast(item)}
                                description={item.name}
                            />
                        </ListItem>
                    )}
                />
            </div>
        </div>
    );
}
